<script setup>
import FavoritesPage from '@/components/FavoritesPage.vue';
import ToastHost from '@/components/base/ToastHost.vue';

</script>

<template>
  <Suspense>
    <FavoritesPage />
  </Suspense>
  <ToastHost />
</template>
